<template>
    <div class="cashup-settings-container">
        <div class="header-container">
        </div>
        <div class="cashupsetting__content">

            <div class="d-flex gap-16 w-100">
                <div class="d-flex flex-column gap-10 m-bottom-1rem w-100">
                    <span class="d-block label">SAFE FLOAT:</span>
                    <div class="d-flex flex-column">
                        <div class="peiso__flex_table">
                            <div class="table__row d-flex h-50">
                                <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 border-bottom-right">
                                    <span>SAFE COUNT FLOAT</span>
                                </div>
                                <div class="header__cell d-flex align-items-center justify-content-center w-100 h-100 border-bottom-right">
                                    <el-input v-model="safeFloat.open" type="number" class="center-align peiso-input-default h-40"></el-input>
                                </div>
                            </div>      
                            <div class="table__row d-flex h-50">
                                <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 border-bottom-right">
                                    <span>PROMO/ACCOUNT LABEL</span>
                                </div>
                                <div class="header__cell d-flex align-items-center justify-content-center w-100 h-100 border-bottom-right">
                                    <el-input v-model="promoLabel" class="center-align peiso-input-default h-40"></el-input>
                                </div>
                            </div>  
                            <div class="table__row d-flex h-50">
                                <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 border-bottom-right">
                                    <span>RECEIPT LABEL</span>
                                </div>
                                <div class="header__cell d-flex align-items-center justify-content-center w-100 h-100 border-bottom-right">
                                    <el-input v-model="receiptLabel" class="center-align peiso-input-default h-40"></el-input>
                                </div>
                            </div> 

                            <div class="table__row d-flex h-50">
                                <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 border-bottom-right">
                                    <span>DEFAULT TILL FLOAT</span>
                                </div>
                                <div class="header__cell d-flex align-items-center justify-content-center w-100 h-100 border-bottom-right">
                                    <el-input v-model="defaultTillFloat" class="center-align peiso-input-default h-40"></el-input>
                                </div>
                            </div> 
                        </div>  
                        <div class="peiso__flex_table">
                            <div class="table__row d-flex h-50">
                                <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 border-bottom-right">
                                    <span>SAFE COUNT VISIBILITY</span>
                                </div>
                                
                                <div class="header__cell d-flex align-items-center justify-content-center h-100 w-100 border-bottom-right">
                                    <el-switch v-model="safeCountVisibility" active-text="Show" inactive-text="Hide" size="large"/>
                                </div>
                            </div>
                        </div>
                        
                        <div class="peiso__flex_table">
                            <div class="table__row d-flex h-50">
                                <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 border-bottom-right">
                                    <span>TAB VARIANCE VISIBILITY</span>
                                </div>
                                <div class="header__cell d-flex align-items-center justify-content-center h-100 w-100 border-bottom-right">
                                    <el-switch v-model="tabVariance" active-text="Show" inactive-text="Hide" size="large"/>
                                </div>
                            </div>
                        </div>  

                        <div class="peiso__flex_table">
                            <div class="table__row d-flex h-50">
                                <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 border-bottom-right">
                                    <span>PROMO/ACCOUNT VISIBILITY</span>
                                </div>
                                
                                <div class="header__cell d-flex align-items-center justify-content-center h-100 w-100 border-bottom-right">
                                    <el-switch v-model="promoVisibility" active-text="Show" inactive-text="Hide" size="large"/>
                                </div>
                            </div>
                        </div>
                        
                        <div class="peiso__flex_table">
                            <div class="table__row d-flex h-50">
                                <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 border-bottom-right">
                                    <span>RECEIPT VISIBILITY</span>
                                </div>
                                
                                <div class="header__cell d-flex align-items-center justify-content-center h-100 w-100 border-bottom-right">
                                    <el-switch v-model="receiptVisibility" active-text="Show" inactive-text="Hide" size="large"/>
                                </div>
                            </div>
                        </div>
                        <div class="peiso__flex_table">
                            <div class="table__row d-flex h-50">
                                <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 border-bottom-right">
                                    <span>AUTO POPULATE</span>
                                </div>
                                
                                <div class="header__cell d-flex align-items-center justify-content-center h-100 w-100 border-bottom-right">
                                    <el-switch v-model="autoPopulate" active-text="Show" inactive-text="Hide" size="large"/>
                                </div>
                            </div>
                        </div>
                        
                        <div v-if="weeklyVisibility" class="peiso__flex_table">
                            <div class="table__row d-flex h-50">
                                <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 border-bottom-right">
                                    <span>CASHUP WEEKLY REPORT</span>
                                </div>
                                
                                <div class="header__cell d-flex align-items-center justify-content-center h-100 w-100 border-bottom-right">
                                    <el-switch v-model="weeklyVisibility" active-text="Enable" inactive-text="Disable" size="large"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex flex-column gap-10 m-bottom-2rem w-100">
                    <span class="d-block label">TILLS LIST</span>
                    
                    <div class="peiso__flex_table">
                        <div class="table__header d-flex">
                            <div class="header__cell d-flex align-items-center justify-content-center w-100 max-w-50 border-bottom-right">
                                <span>#</span>
                            </div>
                            <div class="header__cell d-flex align-items-center justify-content-center w-100 border-bottom-right">
                                <span>Till name</span>
                            </div>
                            
                            <div class="header__cell d-flex align-items-center justify-content-center w-100 max-w-140 border-bottom-right">
                                <span>Till float</span>
                            </div>
                            
                            <div class="header__cell d-flex align-items-center justify-content-center w-100 max-w-140 border-bottom-only">
                                <span>Action</span>
                            </div>
                        </div>

                        <div class="table__row d-flex" v-for="(item, i) in tills" :key="`till-${i}`">
                            <div class="d-flex w-100">
                                <div class="header__cell d-flex align-items-center justify-content-center h-100 w-100 max-w-50 border-bottom-right">
                                    <span>{{ i }}</span>
                                </div>
                                <div class="header__cell d-flex align-items-center justify-content-center h-100 w-100 border-bottom-right">
                                    <span>{{ item.name }}</span>
                                </div>
                                
                                <div class="header__cell d-flex align-items-center justify-content-center h-100 w-100 max-w-140 border-bottom-right">
                                    <span>{{ item.tillFloat }}</span>
                                </div>
                                
                                <div class="header__cell d-flex align-items-center justify-content-center h-100 w-100 max-w-140 border-bottom-only">
                                    <el-button type="peiso-danger" class="w-100" @click="removeTill(i)">REMOVE</el-button>
                                </div>
                            </div>
                        </div>
                        <div class="table__row d-flex">
                            <div class="d-flex w-100">
                                <div class="header__cell d-flex align-items-center justify-content-center h-100 w-100 max-w-50 border-bottom-right">
                                    <span></span>
                                </div>
                                <div class="header__cell d-flex align-items-center justify-content-center h-100 w-100 border-bottom-right">
                                    <el-input v-model="tillName" class="peiso-input-default h-40"></el-input>
                                </div>
                                
                                <div class="header__cell d-flex align-items-center justify-content-center h-100 w-100 max-w-140 border-bottom-right">
                                    <el-input v-model="tillFloat" type="number" class="center-align peiso-input-default h-40"></el-input>
                                </div>
                                
                                <div class="header__cell d-flex align-items-center justify-content-center h-100 w-100 max-w-140 border-bottom-only">
                                    <el-button type="peiso-success" class="w-100" @click="addTills">ADD</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="">
                <el-button type="peiso-primary-pink-border-only" v-if="!isLoading" class="m-auto px-2rem" @click="saveCashupSetting()">
                    Save cashup setting
                </el-button>
                <el-button type="peiso-primary-pink-border-only" v-if="isLoading" class="m-auto px-2rem" @click="saveCashupSetting()">
                    <i class="el-icon-loading"></i> &nbsp;Saving cashup setting...
                </el-button>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
@import 'static/scss/colors';
@import 'static/scss/fonts/fonts';
    .cashup-settings-container {
        .label {
            @include montserrat-font(18px, normal, 600, $white);
            
        }

        .peiso-input-default {
            .el-input__inner {
                font-size: 16px;
                font-weight: 600;
                height: 40px;
            }
        }
    }
</style>

<script>
import cashup from '@/api/cashup'
import utils from '@/utils/utils'
export default {
    data() {
        return {
            safeFloat: {
                open: 0,
                close: 0,
            },
            tills: [],
            tillName: '',
            tillFloat: '',
            isLoading: false,
            tabVariance: true,
            isShowPromo: true,
            promoLabel: "Promo/Account",
            receiptLabel: 'Receipt',
            promoVisibility: true,
            safeCountVisibility: true,
            receiptVisibility: true,
            weeklyVisibility: true,
            defaultTillFloat: 300,
            autoPopulate: false,

        }
    },
    methods: {
        displayCashupSettings() {
            cashup.displaySettings().then((res) => {
                if (res.data.code == 0) {
                    this.safeFloat = res.data.data.safeFloat
                    this.tills = res.data.data.tills
                    this.tabVariance = res.data.data.tabVariance
                    this.promoLabel = res.data.data.promoLabel ? res.data.data.promoLabel : 'Promo/Account'
                    this.receiptLabel = res.data.data.receiptLabel ? res.data.data.receiptLabel : 'Receipt'
                    this.promoVisibility = res.data.data.promoVisibility
                    this.safeCountVisibility = res.data.data.safeCountVisibility
                    this.weeklyVisibility = res.data.data.weeklyVisibility
                    this.receiptVisibility = res.data.data.receiptVisibility
                    this.defaultTillFloat = res.data.data.defaultTillFloat ? res.data.data.defaultTillFloat : 300
                    this.autoPopulate = res.data.data.autoPopulate ? res.data.data.autoPopulate : false
                }
            })
        },

        saveCashupSetting() {
            this.isLoading = true
            cashup.saveSetting({
                safeFloat: this.safeFloat, 
                tills: this.tills, 
                tabVariance: this.tabVariance, 
                promoLabel: this.promoLabel, 
                safeCountVisibility: this.safeCountVisibility,
                promoVisibility: this.promoVisibility, 
                promoLabel: this.promoLabel,
                receiptLabel: this.receiptLabel,
                receiptVisibility: this.receiptVisibility,
                weeklyVisibility: this.weeklyVisibility,
                defaultTillFloat: this.defaultTillFloat,
                autoPopulate: this.autoPopulate,
            }).then((res) => {
                var res = res.data
                if (res.code == 0) {
                    this.safeFloat = res.data.safeFloat
                    this.tills = res.data.tills

                } else {
                    utils.alert2('', res.message, 'error')
                }
                this.isLoading = false
                utils.alert2('', 'Cashup setting successfully update', 'success')
            }).catch((err) => {
                this.isLoading = false
                utils.alert2('', err, 'error')
            })
        },

        removeTill(idx) {
            this.tills.splice(idx, 1)
        },

        addTills() {
            if (this.tillName == '' || this.tillFloat == '') {
                utils.alert2('', 'Please input Till name and Till float', 'error')
                return
            } 

            this.tills.push({
                name: this.tillName,
                tillFloat: this.tillFloat
            })

            
            this.tillName = ''
            this.tillFloat = ''
        }
    },

    mounted() {
        this.displayCashupSettings()
    }
}
</script>


// WEBPACK FOOTER //
// src/components/modal/cashupSetting.vue